import { filterItemByTagId } from '../tags/filterByTagId';
import { sanitizeTextForComparison } from './sanitizeTextForComparison';
import searchTextThemeWeight from './searchTextThemeWeight';

export default function filterThemes({
  themes,
  showFavourites,
  favouriteThemes = [],
  searchText = '',
  language,
  tagIds = [null],
  activityType,
}) {
  const text = sanitizeTextForComparison(searchText);
  const weightedThemes = themes
    .map((theme) => ({
      ...theme,
      weight: searchTextThemeWeight(text, theme),
      isFavourite: favouriteThemes.some(
        (favouriteThemeId) => theme.id == favouriteThemeId
      ),
      activities: theme.activities?.filter(
        (activity) => !activityType || activity.type == activityType
      ),
    }))
    .filter(
      (theme) =>
        (theme.isFavourite || !showFavourites) &&
        theme.weight > 0 &&
        theme.language == language &&
        tagIds.some((tagId) => filterItemByTagId(theme, 'themeTags', tagId)) &&
        (!theme.activities || theme.activities.length > 0)
    )
    .sort((current, next) => {
      return next.weight - current.weight;
    });

  return weightedThemes;
}
